import { saveAs } from 'file-saver';

import ApiService from '../../../services/apiService';
import Endpoints from '../../../services/endpoints';
import { PageParams } from '../../../interfaces/pageSortParams';
import { enqueueSnackbar } from '../notificationActions';
import { SnackbarMessageVariants } from '../../../helpers/enums';

export const BILLING_HISTORY_REQUEST = 'BILLING_HISTORY_REQUEST';
export const BILLING_HISTORY_SUCCESS = 'BILLING_HISTORY_SUCCESS';
export const BILLING_HISTORY_FAILURE = 'BILLING_HISTORY_FAILURE';
export const INVOICE_REQUEST = 'INVOICE_REQUEST';
export const INVOICE_SUCCESS = 'INVOICE_SUCCESS';
export const INVOICE_FAILURE = 'INVOICE_FAILURE';

const DOWNLOAD_TYPE = 'application/pdf;charset=utf-8';

export interface BillingHistoryParams {
    accountId: string;
    page: PageParams;
}

export interface InvoicesResponse {
    content: Invoice[];
    empty: boolean;
    numberOfElements: number;
    offset: number;
    pageNumber: number;
    pageable: any;
    size: number;
    totalPages: number;
    totalSize: number;
    errorMessage?: string;
}

export interface Invoice {
    paymentRefId: string;
    productDescription: string;
    totalAmount: string;
    createdDate: Date;
}

const requestBillingHistory = (params: BillingHistoryParams): object => {
    return {
        type: BILLING_HISTORY_REQUEST,
        payload: params
    };
};

const receiveBillingHistory = (invoicesResponse: InvoicesResponse): object => {
    return {
        type: BILLING_HISTORY_SUCCESS,
        payload: invoicesResponse
    };
};

const requestBillingHistoryFailed = (): object => {
    return {
        type: BILLING_HISTORY_FAILURE
    };
};

export const fetchBillingHistory = (params: BillingHistoryParams): object => {
    return async (dispatch: any): Promise<void> => {
        dispatch(requestBillingHistory(params));

        try {
            const invoicesResponse: InvoicesResponse = await ApiService.get(
                encodeURI(`${Endpoints.getBillingHistory}/${params.accountId}` +
                    `?page=${params.page.currentPage}` +
                    `&size=${params.page.pageSize}`),
                true
            );

            dispatch(receiveBillingHistory(invoicesResponse));
        } catch (err) {
            dispatch(requestBillingHistoryFailed());
            if (Math.floor(err?.response?.data?.errorCode / 100) === 4) {
                dispatch(enqueueSnackbar({
                    message: err.response.data.message,
                    variant: SnackbarMessageVariants.Info
                }));
            } else {
                dispatch(enqueueSnackbar({
                    message: 'Error occurred while fetching billing history.',
                    variant: SnackbarMessageVariants.Error
                }));
            }
        }
    };
};

const requestInvoice = (): object => {
    return {
        type: INVOICE_REQUEST
    };
};

const receiveInvoice = (): object => {
    return {
        type: INVOICE_SUCCESS
    };
};

const requestInvoiceFailed = (): object => {
    return {
        type: INVOICE_FAILURE
    };
};

export const downloadInvoice = (paymentRefId: string): object => {
    return async (dispatch: any): Promise<void> => {
        dispatch(requestInvoice());
        try {

            const rawData = await ApiService.getBlob(`${Endpoints.downloadInvoice}/${paymentRefId}`, true);

            const blob = new Blob([rawData], { type: DOWNLOAD_TYPE });
            saveAs(blob, paymentRefId);

            dispatch(receiveInvoice());
        } catch (err) {
            dispatch(requestInvoiceFailed());
            dispatch(enqueueSnackbar({
                message: `Error occurred while downloading invoice for payment reference id ${paymentRefId}.`,
                variant: SnackbarMessageVariants.Error
            }));
        }
    };
};
